import { React, classNames, withStyles, StyledProps } from '@api'
import { CircularProgress } from '@material-ui/core'
import { CloudUpload, CloudDone } from '@material-ui/icons'

import { PrimaryButton } from './'

const styles = (theme) => ({
  buttonProgress: {
    color: '#FFFFFF'
  },
  rightIcon: {
    marginLeft: theme.spacing(),
    width: theme.libraryTableStyles.components.icon.width,
    height: theme.libraryTableStyles.components.icon.height
  },
  input: {
    display: 'none'
  }
})

interface MyProps extends StyledProps {
  /**
	 * Function to upload file
	 */
  handleSubmit?: (e) => void
  /**
	 * Is upload in progress
	 */
  inProgress?: boolean
  /**
	 * Amount of current upload progress
	 */
  currentProgress: number
  /**
	 * Button label
	 */
  label?: string
  /**
	 * Label while upload in progress
	 */
  progressLabel?: string
}

export class FileUploadButtonComponent extends React.Component<MyProps> {
  static defaultProps = {
    inProgress:    false,
    label:         'Upload',
    progressLabel: 'Uploading',
    currentProgress: 0
    }

  render() {
    const {classes, handleSubmit, inProgress, currentProgress, label, progressLabel, ...other} = this.props
    return (
      <PrimaryButton
        icon={{
          component: inProgress
                     ? <CircularProgress size={24} className={classes.buttonProgress}/>
                     : (currentProgress <= 100
                        ? <CloudUpload/>
                        : <CloudDone/>
                     ),
          position:  'right'
        }}
        onClick={!inProgress ? handleSubmit : () => {}}
        {...other}
      >
        {inProgress ? `${progressLabel} ${currentProgress}%` : label}
      </PrimaryButton>
    )
  }
}

@(withStyles as any)(styles)
export class FileUploadButton extends FileUploadButtonComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/FileUploadButton.tsx